import { Base } from "ui/Scripts/source/framework/base";
import { ListItems } from "ui/Scripts/source/framework/listItems";
import { IRecordFamiliarizationListItem, RecordFamiliarizationListItem } from "ui/Scripts/source/models/recordFamiliarization/recordFamiliarizationListItem";

export interface IRecordFamiliarizationListItems extends ListItems<IRecordFamiliarizationListItem> {
}

export class RecordFamiliarizationListItems extends ListItems<RecordFamiliarizationListItem> implements IRecordFamiliarizationListItems {
    constructor();
    constructor(obj: IRecordFamiliarizationListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, RecordFamiliarizationListItem);
    }
}